import { useEffect, useRef, useState } from "react";
import CryptoJS from "crypto-js";
import MobileHeader from "../../layout/header/mobileHeader";
import WebHeader from "../../layout/header/webHeader";
import { COLORS } from "../../utils/colors";
import {
  Box,
  HStack,
  Pressable,
  Text,
  useMediaQuery,
  VStack,
} from "native-base";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import CommonHeading from "../../components/headings";
import ToggleButton from "../../components/toggle";
import { PackagesCard } from "../../containers/packages";
import { hasPermission } from "../../utils/permission";
import NoDataFound from "../../components/noDataFound";
import { filterSVG } from "../../utils/svg";
import Svg from "react-native-svg";
import PopOverModal from "../../components/popover";
import CustomButton from "../../components/button";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import RadioButtons from "../../components/radioButton";
import MobileModelSheet from "../../components/actionSheet";
import config from "../../utils/config";
import { useSelector } from "react-redux";

const PackagesListingPage = ({
  setPagination = () => {},
  setEvents = () => {},
  setCurrentPage = () => {},
}) => {
  const childref = useRef();
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const activePackagesTab = useSelector((state) => {
    return state.event.activePackagesTab;
  });
  const [tabActiveButton, setTabActiveButton] = useState(activePackagesTab);
  const options = ["New request", "Ongoing package"];
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("content"),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  const [activeButton, setActiveButton] = useState(
    userInfo.role === "employee" ||
      userInfo.role === "admin" ||
      (userInfo.role === "initiator" && MobileWindow)
      ? "package_approved"
      : activePackagesTab === "Ongoing package"
      ? "package_approved"
      : "pending"
  );
  const [showModal, setShowModal] = useState(false);
  const [selectedAgency, setSelectedAgency] = useState("");
  const [filterOptions, setFilterOptions] = useState({
    types: [],
    selected: "",
  });
  const [packagesCount, setPackagesCount] = useState(false);

  useEffect(() => {
    setFilterOptions({
      types: [],
      selected: "",
    });
    setPackagesCount(false);
    setSelectedAgency("");
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
    scrollToTop();
  }, [tabActiveButton]);
  
  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const getPackagesCount = (count) => {
    setPackagesCount(count);
  };

  const handleOptionChange = (e) => {
    let selectedValue = e.target.value;
    let selectedOption = { ...filterOptions, selected: selectedValue };
    selectedOption.selected = selectedValue;
    setFilterOptions(selectedOption);
  };

  const handleListAgency = () => {
    let agency = childref.current.handleAgencyName();
    let options = { ...filterOptions };
    for (var i = 0; i < agency.length; i++) {
      options.types[i] = {
        text: agency[i],
        value: "agency_" + agency[i],
      };
    }
    setFilterOptions(options);
    openModal();
  };

  const getModalChildren = () => {
    return filterOptions.types.map((item) => {
      return (
        <HStack
          space={1.5}
          key={item.value}
          className="radio-btns"
          pr={3}
          alignItems={"center"}
        >
          <input
            type="radio"
            value={item.value}
            checked={filterOptions.selected === item.value}
            onChange={handleOptionChange}
            className="radio-btns"
          />
          <Text
            color={COLORS.PARTNERS_HEADING_COLOR}
            fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
            pt="13px"
            mb={2}
            width={"100%"}
          >
            {item.text}
          </Text>
        </HStack>
      );
    });
  };

  const updateDataTabChange = () => {
    setPagination(0);
    setEvents([]);
    setCurrentPage(1);
    !MobileWindow && setActiveButton("pending");
    !MobileWindow && setTabActiveButton("New request");
    // getEventList("upcoming", 1, 20, "", true);
  };

  return (
    <Box bg={COLORS.THEME_BACKGROUND} pb={8} minHeight={"100vh"}>
      <Box bg={COLORS.WHITE_COLOR} py={1}>
        {MobileWindow ? (
          <MobileHeader
            updateDataTabChange={updateDataTabChange}
            showTabs={true}
          />
        ) : (
          <WebHeader updateDataTabChange={updateDataTabChange} />
        )}
      </Box>
      <VStack
        ml={!MobileWindow && 8}
        mr={!MobileWindow && 8}
        px={MobileWindow ? "25px" : "50px"}
        py="30px"
        space={5}
        minH={"60vh"}
      >
        <HStack justifyContent={"space-between"} alignItems={"center"}>
          <CommonHeading text={"Packages"} />
          {packagesCount &&
            (!MobileWindow ? (
              <PopOverModal
                isOpen={showModal}
                onClose={closeModal}
                onOpenPress={handleListAgency}
                type="comments"
                svg={
                  <Svg width="24" height="24" viewBox="0 0 24 24">
                    {filterSVG}
                  </Svg>
                }
                body={getModalChildren()}
                footer={
                  <HStack
                    mb={3}
                    justifyContent={"space-between"}
                    width={"100%"}
                  >
                    <CustomButton
                      text="No Filter"
                      isOutline
                      bgColor={COLORS.BLACK_COLOR}
                      textColor={COLORS.BLACK_COLOR}
                      onPress={() => {
                        setFilterOptions({ ...filterOptions, selected: "" });
                        setSelectedAgency("");
                        closeModal();
                      }}
                    />
                    <CustomButton
                      text="Apply"
                      onPress={() => {
                        setSelectedAgency(filterOptions.selected.split("_")[1]);
                        closeModal();
                      }}
                    />
                  </HStack>
                }
              />
            ) : (
              <div onClick={() => handleListAgency()}>
                <Svg width="24" height="24" viewBox="0 0 24 24">
                  {filterSVG}
                </Svg>
                {showModal && (
                  <MobileModelSheet
                    isOpen={showModal}
                    onClose={closeModal}
                    header={"Filter"}
                    body={getModalChildren()}
                    footer={
                      <HStack
                        mb={3}
                        justifyContent={"space-between"}
                        width={"100%"}
                      >
                        <CustomButton
                          text="No Filter"
                          isOutline
                          bgColor={COLORS.BLACK_COLOR}
                          textColor={COLORS.BLACK_COLOR}
                          onPress={() => {
                            setFilterOptions({
                              ...filterOptions,
                              selected: "",
                            });
                            setSelectedAgency("");
                            closeModal();
                          }}
                        />
                        <CustomButton
                          text="Apply"
                          onPress={() => {
                            setSelectedAgency(
                              filterOptions.selected.split("_")[1]
                            );
                            closeModal();
                          }}
                        />
                      </HStack>
                    }
                  />
                )}
              </div>
            ))}
        </HStack>
        {!MobileWindow && hasPermission("APPROVE_PACKAGES") && (
          <ToggleButton
            options={options}
            activeButton={tabActiveButton}
            setActiveButton={(value) => {
              if (value === "New request") {
                setActiveButton("pending");
              } else if (value === "Ongoing package") {
                setActiveButton("package_approved");
              }
              setTabActiveButton(value);
            }}
          />
        )}
        <Box mt={3}>
          <PackagesCard
            activeButton={activeButton}
            selectedAgency={selectedAgency}
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
            ref={childref}
            getPackagesCount={getPackagesCount}
          />
        </Box>
      </VStack>
    </Box>
  );
};

export default PackagesListingPage;
